import type { ComposerTranslation } from 'vue-i18n';

export const getBedroomsLabel = (t: ComposerTranslation, model: { bedrooms: number | null; bedroomsMax?: number | null }): string => {
  const bedroomsMax = model.bedroomsMax ?? null;
  if (model.bedrooms !== null && bedroomsMax !== null) {
    const min = model.bedrooms === 0 ? t('views.project.characteristics.loft-studio') : model.bedrooms;
    return t('views.project.characteristics.bedrooms-range', { min, max: bedroomsMax }, bedroomsMax);
  }

  return model.bedrooms === 0 ? t('views.project.characteristics.loft-studio') : t('views.project.characteristics.bedrooms', model.bedrooms ?? 0);
};
